module.exports = __webpack_public_path__ + "img/20220423_160830.dc80b4a2.jpg";